import React, { useState } from "react";
import Footer from "../components/homeComponents/Footer";
import classes from "./HomeLayout.module.css";
import logo from "../assets/icons/new logo-m.png";
import wrench from "../assets/icons/avatar.jpg";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { FiLogOut } from "react-icons/fi";
import {
  IoSettingsOutline,
  IoNewspaperOutline,
  IoHomeOutline,
} from "react-icons/io5";
import { TbPackages } from "react-icons/tb";
import { Modal, Button } from "react-bootstrap"; // Import React Bootstrap Modal and Button

function HomeLayout(props) {
  const [showModal, setShowModal] = useState(false); // State for modal visibility
  const name = localStorage.getItem("username");
  const navigator = useNavigate();

  // Function to handle the logout process
  function signOut() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );

    var urlencoded = new URLSearchParams();
    urlencoded.append("refresh_token", localStorage.getItem("refresh_token"));

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_API_URL}/api/v1/user/logout`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("username");
        navigator("/login");
      })
      .catch((error) =>
        toast.error("خطا در خروج رخ داده است دوباره امتحان کنید")
      );
  }

  // Function to handle logout click
  const handleLogoutClick = () => {
    setShowModal(true); // Show modal when the logout button is clicked
  };

  // Function to handle the modal confirmation
  const handleConfirmLogout = () => {
    setShowModal(false); // Close the modal
    signOut(); // Call the signOut function to log out the user
  };

  // Function to handle modal cancellation
  const handleCancelLogout = () => {
    setShowModal(false); // Close the modal without logging out
  };

  return (
    <div className={classes.firstLayer}>
      <div className={classes.header}>
        <div className={classes.logo_Container}>
          <img className={classes.nkh_logo} alt="logo" src={logo}></img>
        </div>
        <div className={classes.menu}>
          <div className={classes.home} onClick={() => navigator("/")}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "28px",
              }}
            >
              <IoHomeOutline size={22} />
              <span style={{ marginRight: "5px" }}>خانه</span>
            </div>
          </div>
          <div onClick={() => navigator("/notification")}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "23px",
              }}
            >
              <IoNewspaperOutline size={22} />
              <span style={{ marginRight: "5px" }}>خبرها</span>
            </div>
          </div>
          <div onClick={() => navigator("/package")}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "23px",
              }}
            >
              <TbPackages size={22} />
              <span style={{ marginRight: "5px" }}>پکیج</span>
            </div>
          </div>
          <div onClick={() => navigator("/setting")}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "20px",
              }}
            >
              <IoSettingsOutline size={22} />
              <span style={{ marginRight: "5px" }}>تنظیمات</span>
            </div>
          </div>
          <div onClick={handleLogoutClick} className={classes.logoutButton}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "23px",
              }}
            >
              <FiLogOut size={22} />
              <span style={{ marginRight: "5px" }}>خروج</span>
            </div>
          </div>
        </div>
        <div className={classes.profile_Container}>
          <div className={classes.profile_text_container}>
            <div className={classes.profile_text_name_container}>
              {name !== "undefined" ? name : "-"}
            </div>
            <div className={classes.profile_text_description_container}>
              مکانیک خودرو
            </div>
          </div>
          <div className={classes.profile_photo_container}>
            <img className={classes.avatar} alt="logo" src={wrench}></img>
          </div>
        </div>
      </div>

      <main className={classes.main}>
        {props.children}
        <Footer />
      </main>

      {/* React Bootstrap Modal */}
      <Modal
        style={{ direction: "rtl" }}
        show={showModal}
        onHide={handleCancelLogout}
      >
        <Modal.Header>
          <Modal.Title>
            <FiLogOut />
            <span style={{ marginRight: "5px" }}>تأیید خروج</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>آیا مطمئن هستید که می‌خواهید خارج شوید؟</Modal.Body>
        <Modal.Footer>
          <button className="btn btn-outline-dark" onClick={handleCancelLogout}>
            انصراف
          </button>
          <button className="btn btn-danger px-5" onClick={handleConfirmLogout}>
            تأیید
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default HomeLayout;
